function debounce(func, delay) {
  let timeoutId;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

class Carousel {
  constructor(options) {
    this.carouselInner = document.getElementById(options.carouselId);

    this.slides = this.carouselInner.querySelectorAll(".carousel-item");
    this.slidesToShow = options.slidesToShow || 1;
    this.groupSize = options.groupSize || 1;
    this.carouselDots =
      this.carouselInner.parentNode.querySelector("#carouselDots");
    this.totalSlides = this.slides.length;
    this.currentIndex = 0;
    this.infinite = options.infinite || false;

    this.dragStartX = 0;
    this.dragEndX = 0;

    this.initCarousel();
  }

  initCarousel() {
    const parentWidth = this.carouselInner.parentElement.offsetWidth;
    const marginRight = parseFloat(
      getComputedStyle(this.slides[0]).marginRight
    );
    const marginLeft = parseFloat(getComputedStyle(this.slides[0]).marginLeft);

    const itemWidth =
      parentWidth / this.slidesToShow - (marginRight + marginLeft);

    this.slides.forEach((item) => {
      if (!this.infinite) item.style.minWidth = `${itemWidth}px`;

      this.carouselInner.parentElement.addEventListener("mousedown", (e) => this.dragStart(e));
      this.carouselInner.parentElement.addEventListener("touchstart", (e) => this.dragStart(e), {
        passive: true,
      });
    });

    const totalDots = Math.ceil(this.totalSlides / this.groupSize);

    for (let i = 0; i < totalDots; i++) {
      const dotElement = document.createElement("li");
      dotElement.classList.add("dot");
      dotElement.addEventListener("click", () =>
        debounce(this.goToSlide(i * this.groupSize), 500)
      );
      this.carouselDots?.appendChild(dotElement);
    }

    this.updateCarousel();
  }

  dragStart(e) {
    this.dragStartX = e.clientX || e.touches[0].clientX;
    document.addEventListener("mousemove", this.dragMove);
    document.addEventListener("mouseup", this.dragEnd);
    document.addEventListener("touchmove", this.dragMove, { passive: true });
    document.addEventListener("touchend", this.dragEnd, { passive: true });
  }

  dragMove = (e) => {
    this.dragEndX = e.clientX || e.touches[0].clientX;
  };

  dragEnd = () => {
    document.removeEventListener("mousemove", this.dragMove);
    document.removeEventListener("mouseup", this.dragEnd);
    document.removeEventListener("touchmove", this.dragMove);
    document.removeEventListener("touchend", this.dragEnd);

    const dragDiff = this.dragEndX - this.dragStartX;
    if (dragDiff > 50) {
      this.prevSlide();
    } else if (dragDiff < -50) {
      this.nextSlide();
    }

    this.dragStartX = 0;
    this.dragEndX = 0;
  };

  updateCarousel() {
    console.log("index=", this.currentIndex, "total=", this.totalSlides, "show=", this.slidesToShow);
    const translateValue =
    this.infinite ?
    -this.currentIndex * (100 / (this.totalSlides - this.slidesToShow )) + "%" :
      -this.currentIndex * (100 / Math.min(this.slidesToShow, this.totalSlides)) + "%";
    this.carouselInner.style.transform = "translateX(" + translateValue + ")";
    this.updateDots();
  }

  updateDots() {
    const dotElements = this.carouselInner.parentNode.querySelectorAll(".dot");
    dotElements.forEach((dot, index) => {
      dot.classList.toggle(
        "active",
        index === Math.floor(this.currentIndex / this.groupSize)
      );
    });
  }

  nextSlide() {
    console.log(this.currentIndex, this.totalSlides);
    // if (this.infinite || this.currentIndex < this.totalSlides - 1) {
    //   this.currentIndex = (this.currentIndex + 1) % this.totalSlides;

    //   this.updateCarousel();
    // }

    // if (
    //   this.infinite ||
    //   this.currentIndex < this.totalSlides - this.slidesToShow
    // ) {
    //   if (this.currentIndex < this.totalSlides - this.slidesToShow) {
    //     this.currentIndex += this.slidesToShow;
    //   } else {
    //     this.currentIndex = 0;
    //   }
    //   this.updateCarousel();
    // }

    if (
      this.infinite ||
      this.currentIndex < this.totalSlides - this.slidesToShow
    ) {
      const nextIndex = this.currentIndex +  this.slidesToShow;

      if (nextIndex < this.totalSlides) {
        this.currentIndex = nextIndex;
      } else {
        this.currentIndex = 0;
      }
      this.updateCarousel();
    }
  }

  prevSlide() {
    if (this.infinite || this.currentIndex > 0) {
      const prevIndex = this.currentIndex - this.slidesToShow;

      if (prevIndex >= 0) {
        this.currentIndex = prevIndex;
      } else {
        this.currentIndex = this.totalSlides - this.slidesToShow;
      }
      this.updateCarousel();
    }
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateCarousel();
  }
}

